// Robinhood Chain is the default network for wallet connections.
// Source: https://robinhood.com/us/en/support/articles/robinhood-chain-mainnet/
export const robinhoodChain = {
  chainId: 4663,
  chainIdHex: '0x1237',
  chainName: 'Robinhood Chain',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18
  },
  rpcUrls: ['https://rpc.mainnet.chain.robinhood.com'],
  blockExplorerUrls: ['https://robinhoodchain.blockscout.com']
};

export const environment = {
  production: false,

  baseurl: 'https://api.aegislaunchpad.io/api/',
  blobUrl: 'https://api.aegislaunchpad.io/',

  blockNativeKey: '',

  robinhoodChain: robinhoodChain,

  // $AEGIS Protection Tier thresholds, expressed as a % of total supply.
  aegisTotalSupply: 1000000000,
  aegisTiers: [
    { tier: 1, name: 'Shield', requiredSupplyPercent: 0.1, maxCoveragePercent: 25 },
    { tier: 2, name: 'Guardian', requiredSupplyPercent: 0.2, maxCoveragePercent: 50 },
    { tier: 3, name: 'Sentinel', requiredSupplyPercent: 0.5, maxCoveragePercent: 75 },
    { tier: 4, name: 'Aegis', requiredSupplyPercent: 1.0, maxCoveragePercent: 100 }
  ],

  specialid: 0,
  specialid_third: 0,
  specialidprivate: 0,
  countdown: '',

  storageKeys: {
    fichas: 'aeg_fichas',
    user: 'aeg_user'
  }
};
